import React from "react";
import { useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import './Testimonials.css';

function Testimonials() {

   const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const testimonials = [
    {
      name: "Sarah M.",
      text: "Amazing workmanship from start to finish. Everything was completed cleanly, tidily and with real attention to detail. The whole job felt stress‑free because he explained what was happening at each stage and kept the place spotless throughout. Truly professional service."
    },
    {
      name: "James P.",
      text: "Turned up exactly on time and got straight to work. He did a brilliant job and made sure I understood everything he was doing, which gave me a lot of confidence. The finish was excellent, and the whole experience was smooth and well organised."
    },
    {
      name: "Laura K.",
      text: "Quality finish and a really high standard of work. He took the time to make sure everything was perfect and checked that I was happy before leaving. I’d definitely recommend him to anyone needing plumbing or heating work — reliable, friendly and skilled."
    }
  ];


  return (
    <>
      <NavBar mode="testimonials" />

      <h2 className={`page-header ${visible ? "visible" : ""}`}>
      Testimonials
    </h2>


      <div className="testimonials-list">
        {testimonials.map((t, index) => (
          <div className="testimonial-item" key={index}>
            <p className="testimonial-text">"{t.text}"</p>
            <p className="testimonial-name">- {t.name}</p>
          </div>
        ))}
      </div>
       <Footer />
    </>
  );
}

export default Testimonials;

